import script from "./FileDownloadPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileDownloadPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./FileDownloadPopUp.vue?vue&type=style&index=0&id=427684d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427684d5"]])

export default __exports__